import React from "react";
import { Linkedin } from "lucide-react";

const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="bg-sun-ink text-sun-bg pt-24 pb-10 relative overflow-hidden"
        >
            <div className="absolute -bottom-40 -right-40 w-[40rem] h-[40rem] sun-rays opacity-20 animate-spin-slow pointer-events-none" />
            <div className="absolute -bottom-20 right-20 w-96 h-96 rounded-full bg-sunrise opacity-25 blur-3xl pointer-events-none" />

            <div className="container-x relative">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 md:mb-20">
                    <div className="flex items-center gap-6">
                        <div className="w-24 h-24 md:w-32 md:h-32 bg-white rounded-3xl p-3 flex items-center justify-center">
                            <img src="/logo.jpg" alt="Ostrich" className="w-full h-full object-contain" />
                        </div>
                        <div>
                            <h2 className="font-heading text-5xl md:text-7xl leading-[0.85] tracking-[-0.02em]">
                                Ostrich
                                <span className="display-italic text-gradient"> Foods</span>
                            </h2>
                            <p className="font-mono text-xs uppercase tracking-[0.3em] text-sun-goldSoft mt-3">
                                Make your health better
                            </p>
                            <div
                                data-testid="footer-raj-group"
                                className="mt-5 inline-flex items-center gap-3 bg-white/5 border border-white/10 rounded-full py-2 pl-2 pr-4"
                            >
                                <div className="w-7 h-7 rounded-full bg-white p-0.5 flex items-center justify-center">
                                    <img
                                        src="/brand/raj-group-white.png"
                                        alt="Raj Group"
                                        className="w-full h-full object-contain"
                                    />
                                </div>
                                <span className="font-mono text-[10px] uppercase tracking-[0.26em] text-white/70">
                                    A <span className="text-sun-gold font-semibold">Raj Group</span> company
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col gap-3">
                        <a
                            href="https://www.linkedin.com/company/ostrich-foods/"
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-linkedin"
                            className="inline-flex items-center gap-3 px-5 py-3 rounded-full border border-white/15 hover:border-sun-orange hover:bg-sun-orange transition-colors group"
                        >
                            <Linkedin className="w-4 h-4" strokeWidth={2} />
                            <span className="font-mono text-[10px] uppercase tracking-[0.28em]">
                                Follow on LinkedIn
                            </span>
                        </a>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16 border-t border-white/15 pt-12">
                    <div className="md:col-span-5">
                        <p className="text-white/70 text-base leading-relaxed max-w-md">
                            Naturally dried, chemical-free fruit & vegetable powders. Crafted
                            in Surat, India — sent to formulators, bakers, and brand-builders
                            worldwide.
                        </p>

                        <div className="mt-8 flex items-center gap-3">
                            <a
                                href="https://www.linkedin.com/company/ostrich-foods/"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="LinkedIn"
                                className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-sun-orange hover:border-sun-orange transition-colors"
                            >
                                <Linkedin className="w-4 h-4" strokeWidth={2} />
                            </a>
                            <a
                                href="https://www.indiamart.com/ostrich-food-product/"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="IndiaMART"
                                data-testid="footer-indiamart"
                                className="h-10 px-3 rounded-full border border-white/15 flex items-center justify-center gap-1.5 hover:bg-sun-orange hover:border-sun-orange transition-colors"
                            >
                                <span className="font-heading text-sm leading-none text-sun-gold group-hover:text-white">im</span>
                                <span className="font-mono text-[9px] uppercase tracking-[0.22em] leading-none">IndiaMART</span>
                            </a>
                            <a
                                href="https://in1576199857qgdy.trustpass.alibaba.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Alibaba"
                                data-testid="footer-alibaba"
                                className="h-10 px-3 rounded-full border border-white/15 flex items-center justify-center gap-1.5 hover:bg-sun-orange hover:border-sun-orange transition-colors"
                            >
                                <span className="font-heading text-sm leading-none text-sun-gold group-hover:text-white">A.</span>
                                <span className="font-mono text-[9px] uppercase tracking-[0.22em] leading-none">Alibaba</span>
                            </a>
                            <a
                                href="https://wa.me/919737028999?text=Hi%20Ostrich%20Foods%2C%20I%27d%20like%20to%20know%20more%20about%20your%20powders."
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="WhatsApp"
                                className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-sun-orange hover:border-sun-orange transition-colors"
                            >
                                <svg viewBox="0 0 32 32" className="w-4 h-4 fill-current">
                                    <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.36 0 .59-.013.95-.103.39-.087.945-.36 1.146-.658.158-.225.158-.516.158-.79 0-.143 0-.272-.043-.402-.058-.245-1.448-1.058-1.79-1.058-.142.143-.715.6-.86.6zm-3.4 7.058h-.014a9.875 9.875 0 0 1-5.034-1.376l-.36-.215-3.74.975 1.002-3.638-.236-.374a9.847 9.847 0 0 1-1.51-5.26c0-5.45 4.43-9.88 9.892-9.88 2.64 0 5.122 1.03 6.99 2.898a9.86 9.86 0 0 1 2.89 6.987c-.003 5.45-4.434 9.882-9.88 9.882zm8.413-18.297A11.815 11.815 0 0 0 15.71 2.5C9.143 2.5 3.797 7.847 3.795 14.418c0 2.1.55 4.148 1.59 5.952L3.7 26.5l6.27-1.644a11.86 11.86 0 0 0 5.668 1.444h.005c6.564 0 11.91-5.346 11.913-11.918a11.82 11.82 0 0 0-3.473-8.42z" />
                                </svg>
                            </a>
                        </div>
                    </div>

                    <div className="md:col-span-2">
                        <div className="overline text-sun-goldSoft mb-4">Shop</div>
                        <ul className="space-y-3 text-sm text-white/80">
                            <li><a href="#products" className="hover:text-sun-orange transition-colors">All powders</a></li>
                            <li><a href="#products" className="hover:text-sun-orange transition-colors">Fruits</a></li>
                            <li><a href="#products" className="hover:text-sun-orange transition-colors">Vegetables</a></li>
                            <li><a href="#bulk" className="hover:text-sun-orange transition-colors">Bulk / B2B</a></li>
                        </ul>
                    </div>
                    <div className="md:col-span-2">
                        <div className="overline text-sun-goldSoft mb-4">Company</div>
                        <ul className="space-y-3 text-sm text-white/80">
                            <li><a href="#about" className="hover:text-sun-orange transition-colors">Our story</a></li>
                            <li><a href="#process" className="hover:text-sun-orange transition-colors">Process</a></li>
                            <li><a href="#contact" className="hover:text-sun-orange transition-colors">Contact</a></li>
                            <li>
                                <a
                                    href="https://www.linkedin.com/company/ostrich-foods/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:text-sun-orange transition-colors"
                                >
                                    LinkedIn
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.indiamart.com/ostrich-food-product/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:text-sun-orange transition-colors"
                                >
                                    IndiaMART
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://in1576199857qgdy.trustpass.alibaba.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:text-sun-orange transition-colors"
                                >
                                    Alibaba — Verified
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="md:col-span-3">
                        <div className="overline text-sun-goldSoft mb-4">Trade desk</div>
                        <a
                            href="mailto:trade@ostrichfoods.in"
                            className="block font-heading display-italic text-2xl text-white hover:text-sun-orange transition-colors mb-2"
                        >
                            trade@ostrichfoods.in
                        </a>
                        <a
                            href="tel:+919737028999"
                            className="block font-mono text-sm text-white/70 hover:text-sun-orange transition-colors"
                        >
                            +91 9737 028 999
                        </a>
                    </div>
                </div>

                <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8 border-t border-white/15 text-[11px] font-mono uppercase tracking-[0.28em] text-white/50">
                    <div className="flex items-center gap-3 flex-wrap">
                        <span>© {new Date().getFullYear()} Ostrich Foods · Surat, India · Est. 2025</span>
                    </div>
                    <div className="flex items-center gap-3 flex-wrap">
                        <span className="px-2 py-1 rounded bg-white/10 text-sun-gold tracking-[0.18em] font-bold">FSSAI</span>
                        <span className="text-white/70 normal-case tracking-wider">
                            Lic. No. <span className="text-white font-semibold">10725997001012</span>
                        </span>
                    </div>
                    <div className="flex items-center gap-3">
                        <span className="text-sun-gold">✦</span>
                        Crafted with intent · No additives · No shortcuts
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
